// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1KUlR","paramInput":"JobSimulator_paramInput__2y-CG","input":"JobSimulator_input__3UMh7"};